define('areas/home/model/sidebaritem',["require", "exports"], function (require, exports) {
    "use strict";
    var SidebarItem = (function () {
        function SidebarItem(group, items) {
            var _this = this;
            this.data = null;
            this._group = group;
            this._items = items;
            ko.track(this, ["data"]);
            // init data
            if (this._items.length === 1) {
                var handler = this._items[0].liveTileHandler;
                handler.onRendered(null);
                ko.getObservable(handler, "data").subscribe(function (x) {
                    _this.data = x;
                }, this);
                this.data = handler.data;
            }
        }
        Object.defineProperty(SidebarItem.prototype, "group", {
            get: function () {
                return this._group;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SidebarItem.prototype, "title", {
            get: function () {
                return this._group.title;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SidebarItem.prototype, "embedApp", {
            get: function () {
                if (this._items.length === 1)
                    return this._items[0].application.embedApp || this.alwaysShowTiles;
                return true;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SidebarItem.prototype, "isExternal", {
            get: function () {
                if (this._items.length === 1)
                    return this._items[0].application.isExternalApp;
                return false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SidebarItem.prototype, "childs", {
            get: function () {
                return this._items;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SidebarItem.prototype, "index", {
            get: function () {
                return this._group.index;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SidebarItem.prototype, "appendSeparator", {
            get: function () {
                return this.title === "Personal" ||
                    this.title === "Personal und Zeiten" ||
                    this.title === "Postfach";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SidebarItem.prototype, "prependSeparator", {
            get: function () {
                return this.title === "Einstellungen";
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SidebarItem.prototype, "icon", {
            get: function () {
                return this._group.icon;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SidebarItem.prototype, "useImage", {
            get: function () {
                return this._group.useImage || false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SidebarItem.prototype, "imagePath", {
            get: function () {
                return this._group.imagePath;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SidebarItem.prototype, "hideFromSidenav", {
            get: function () {
                return this._group.hideFromSidenav || false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SidebarItem.prototype, "alwaysShowTiles", {
            get: function () {
                return this._group.alwaysShowTiles || false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(SidebarItem.prototype, "showOnMobile", {
            get: function () {
                return this._group.showOnMobile || false;
            },
            enumerable: true,
            configurable: true
        });
        return SidebarItem;
    }());
    return SidebarItem;
});

